export const countriesData = [
  {
    countryCode: 'AF',
    numericCode: '004',
    countryLabel: 'Afghanistan',
    countryCommonLabel: 'Afghanistan',
  },
  {
    countryCode: 'BE',
    numericCode: '056',
    countryLabel: 'Belgium',
    countryCommonLabel: 'Belgium',
    contentLanguage: 'en',
  },
  {
    countryCode: 'DE',
    numericCode: '276',
    countryLabel: 'Germany',
    countryCommonLabel: 'Germany',
    contentLanguage: 'en',
  },
  {
    countryCode: 'FR',
    numericCode: '250',
    countryLabel: 'France',
    countryCommonLabel: 'France',
  },
  {
    countryCode: 'IT',
    numericCode: '380',
    countryLabel: 'Italy',
    countryCommonLabel: 'Italy',
  },
  {
    countryCode: 'RU',
    numericCode: '643',
    countryLabel: 'Russian Federation (the)',
    countryCommonLabel: 'Russian Federation',
  },
  {
    countryCode: 'KP',
    numericCode: '408',
    countryLabel: "Korea (the Democratic People's Republic of)",
    countryCommonLabel: "Korea, Demo. People's R.",
    contentLanguage: 'en',
  },
  {
    countryCode: 'SE',
    numericCode: '752',
    countryLabel: 'Sweden',
    countryCommonLabel: 'Sweden',
    contentLanguage: 'en',
  },
  {
    countryCode: 'FI',
    numericCode: '246',
    countryLabel: 'Finland',
    countryCommonLabel: 'Finland',
    contentLanguage: 'en',
  },
  {
    countryCode: 'DK',
    numericCode: '208',
    countryLabel: 'Denmark',
    countryCommonLabel: 'Denmark',
    contentLanguage: 'en',
  },
  {
    countryCode: 'NO',
    numericCode: '578',
    countryLabel: 'Norway',
    countryCommonLabel: 'Norway',
    contentLanguage: 'en',
  },
];
